import { createLinearProgress } from "./createLinearProgress";

export const LinearProgress = createLinearProgress({});
